(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunforge-featured-coffee"] && !Shopify.designMode) return;
  try {
    
const sfCartDrawer = document.querySelector('cart-drawer-component');
if (sfCartDrawer) sfCartDrawer.setAttribute('auto-open', '');
document.addEventListener('change', (event) => {
  const select = event.target;
  if (!(select instanceof HTMLSelectElement) || !select.matches('[data-sf-format]')) return;
  const form = select.closest('form');
  const option = select.selectedOptions[0];
  if (!form || !option) return;
  const quantity = form.querySelector('[name="quantity"]');
  const price = form.querySelector('[data-sf-price]');
  if (quantity) quantity.value = option.dataset.quantity || '1';
  if (price) price.textContent = option.dataset.price || '';
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunforge-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    root.querySelectorAll('[data-sfh]').forEach((header) => {
      if (header.dataset.ready) return;
      header.dataset.ready = 'true';
      const button = header.querySelector('.sfh__menu-btn');
      const panel = header.querySelector('.sfh__panel');
      if (!button || !panel) return;
      const closeButton = header.querySelector('.sfh__close');
      header.querySelector('.sfh__cart')?.addEventListener('click', (event) => {
        const drawer = document.getElementById('cart-drawer');
        if (!drawer || typeof drawer.open !== 'function') return;
        event.preventDefault();
        drawer.open();
      });
      const focusable = () => Array.from(panel.querySelectorAll('a[href], button:not([disabled])'));
      const isOpen = () => header.classList.contains('is-open');
      const setOpen = (open, returnFocus) => {
        header.classList.toggle('is-open', open);
        button.setAttribute('aria-expanded', String(open));
        document.documentElement.classList.toggle('sfh-lock', open);
        if (open) {
          panel.removeAttribute('inert');
          (closeButton || focusable()[0]).focus();
        } else {
          panel.setAttribute('inert', '');
          if (returnFocus) button.focus();
        }
      };
      button.addEventListener('click', () => setOpen(!isOpen(), true));
      header.querySelectorAll('[data-sfh-close]').forEach(el => el.addEventListener('click', () => setOpen(false, true)));
      panel.querySelectorAll('a[href]').forEach(el => el.addEventListener('click', () => setOpen(false, false)));
      document.addEventListener('keydown', (event) => {
        if (!isOpen()) return;
        if (event.key === 'Escape') { setOpen(false, true); return; }
        if (event.key !== 'Tab') return;
        const items = focusable();
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
      const onScroll = () => {
        const hero = document.querySelector('.sf-hero');
        const scrollTop = Math.max(window.scrollY, document.documentElement.scrollTop, document.body.scrollTop);
        header.classList.toggle('is-solid', !hero || scrollTop > 24 || hero.getBoundingClientRect().top < -24);
      };
      onScroll();
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunforge-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (root) => {
    root.querySelectorAll('.sf-hero__scene').forEach((scene) => {
      if (scene.dataset.initialized) return;
      const video = scene.querySelector('video');
      const button = scene.querySelector('button');
      if (!video || !button) return;
      scene.dataset.initialized = 'true';
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const loadVideo = () => {
        if (video.dataset.loaded) return;
        video.querySelectorAll('source').forEach(source => source.src = source.dataset.src);
        video.dataset.loaded = 'true';
        video.load();
      };
      const update = () => {
        const label = video.paused ? button.dataset.play : button.dataset.pause;
        button.textContent = video.paused ? '▶ PLAY' : 'Ⅱ PAUSE';
        button.setAttribute('aria-label', label);
        scene.classList.toggle('is-playing', !video.paused);
      };
      const play = () => { loadVideo(); video.play().catch(update); };
      button.hidden = false;
      video.addEventListener('play', () => {scene.classList.add('has-played'); update();});
      video.addEventListener('pause', update);
      video.addEventListener('error', () => {scene.classList.remove('has-played'); button.hidden = true;});
      button.addEventListener('click', () => video.paused ? play() : video.pause());
      motion.addEventListener('change', () => {
        if (motion.matches) {video.pause(); scene.classList.remove('has-played');}
      });
      if (!motion.matches) play();
      update();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sunforge-subscriptions"] && !Shopify.designMode) return;
  try {
    
function initializeSunForgeSubscriptions(root = document) {
  root.querySelectorAll('.sf-sub__gift-purchase').forEach((purchase) => {
    const form = purchase.querySelector('.sf-sub__gift-form');
    const link = purchase.querySelector('.sf-sub__gift-recipient');
    if (!form || !link || form.dataset.recipientLinkInitialized) return;
    form.dataset.recipientLinkInitialized = 'true';
    const updateRecipientLink = () => {
      const selected = form.querySelector('input[name="id"]:checked');
      if (!selected) return;
      const url = new URL(link.href);
      url.searchParams.set('variant', selected.value);
      url.searchParams.set('recipient', '1');
      link.href = url.href;
    };
    form.addEventListener('change', updateRecipientLink);
    updateRecipientLink();
  });
  root.querySelectorAll('[data-sf-sub-form]').forEach((form) => {
    if (form.dataset.initialized) return;
    const section = form.closest('.sf-sub');
    const source = section.querySelector('[data-sf-sub-data]');
    let data;
    try { data = JSON.parse(source.textContent); } catch { return; }
    form.dataset.initialized = 'true';
    const coffee = form.querySelector('[data-sf-sub-coffee]');
    const quantity = form.querySelector('[data-sf-sub-quantity]');
    const plan = form.querySelector('[data-sf-sub-plan]');
    const variant = form.querySelector('[data-sf-sub-variant]');
    const total = form.querySelector('[data-sf-sub-total]');
    const status = form.querySelector('[data-sf-sub-status]');
    const button = form.querySelector('button[type="submit"]');
    const money = new Intl.NumberFormat(data.locale || 'en-US', {style:'currency',currency:data.currency});
    const update = () => {
      const item = data.coffees[coffee.value];
      const allocation = item?.plans.find((candidate) => String(candidate.id) === plan.value);
      const count = Number(quantity.value);
      const validCount = Number.isSafeInteger(count) && count >= 1;
      const purchasable = !!(item?.available && allocation && /^\d+$/.test(String(item.variant)) && /^\d+$/.test(String(allocation.id)) && validCount && (!item.tracked || item.inventory >= count));
      variant.value = purchasable ? String(item.variant) : '';
      button.disabled = !purchasable;
      total.textContent = allocation && validCount ? `${item.available ? data.labels.total : data.labels.estimate} ${money.format(allocation.price * count / 100)} ${data.labels.per_delivery}` : '';
      status.textContent = !validCount ? data.labels.invalid_quantity : !item ? data.labels.prompt : !item.available ? data.labels.unavailable : !allocation ? data.labels.no_plan : !purchasable ? data.labels.unavailable : data.labels.ready;
    };
    coffee.addEventListener('change', () => {
      const item = data.coffees[coffee.value];
      plan.replaceChildren(new Option(data.labels.choose, ''));
      for (const allocation of item?.plans || []) plan.add(new Option(allocation.name, String(allocation.id)));
      plan.disabled = !item;
      update();
    });
    quantity.addEventListener('input', update);
    quantity.addEventListener('change', update);
    plan.addEventListener('change', update);
    form.addEventListener('submit', (event) => {
      update();
      if (button.disabled) { event.preventDefault(); return; }
      button.disabled = true;
    });
    update();
  });
}
initializeSunForgeSubscriptions();
document.addEventListener('shopify:section:load', (event) => initializeSunForgeSubscriptions(event.target));

  } catch(e) { console.error(e); }
})();
})();
